import { DropzoneComposition } from '@codeleap/web'
import { textVariant } from './Text'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

const createDropzoneVariant = createStyles<DropzoneComposition>

export const DropzoneStyles = {
  default: createDropzoneVariant((theme) => ({
    wrapper: {},
    dropzone: {
      ...theme.presets.flex,
      ...theme.presets.column,
      borderRadius: theme.radius.large,
      padding: theme.spacing.value(3),
      border: `1.5px dashed ${theme.baseColors.neutralSolid400}`,
      ...theme.presets.alignCenter,
      ...theme.presets.justifyCenter,
      cursor: 'pointer',
    },
    iconWrapper: {
      borderRadius: theme.radius.infinite,
      backgroundColor: theme.baseColors.neutralSolid200,
      ...theme.sized(7),
      ...theme.presets.justifyCenter,
      ...theme.presets.alignCenter,
      marginBottom: theme.spacing.value(2),
    },
    icon: {
      ...theme.sized(3),
    },
    placeholder: {
      ...textVariant('p3'),
      fontWeight: 'normal',
      width: '78%',
      color: theme.baseColors.neutralSolid700,
      ...theme.presets.textCenter,
    },
    filesWrapper: {
      ...theme.presets.column,
      ...theme.presets.fullWidth,
      marginBottom: theme.spacing.value(2),
      gap: theme.spacing.value(1),
    },
    fileWrapper: {
      ...theme.presets.row,
      ...theme.presets.fullWidth,
      height: theme.spacing.value(6),
      paddingRight: theme.spacing.value(2),
      paddingLeft: theme.spacing.value(2),
      borderRadius: theme.radius.large,
      backgroundColor: theme.baseColors.neutralSolid200,
      ...theme.presets.alignCenter,
    },
    'fileWrapper:error': {
      border: `1.5px solid ${theme.baseColors.redSolid100}`,
    },
    fileErrors: {},
    fileError: {
      ...textVariant('p4'),
      color: theme.baseColors.redSolid400,
    },
    fileNameWrapper: {
      ...theme.presets.flex,
      ...theme.presets.column,
    },
    fileName: {
      ...theme.presets.flex,
      ...textVariant('p1'),
      color: theme.baseColors.neutralSolid700,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    fileLeftIcon: {
      marginRight: theme.spacing.value(1),
      color: theme.baseColors.neutralSolid700,
      ...theme.sized(2.5),
    },
    fileRightIconTouchableWrapper: {
      marginLeft: theme.spacing.value(1),
      background: 'none',
      ...theme.sized(2.5),
    },
    fileRightIconIcon: {
      color: theme.baseColors.neutralSolid800,
    },
    fileImage: {
      ...theme.sized(4),
      borderRadius: theme.radius.infinite,
      marginRight: theme.spacing.value(1),
      objectFit: 'cover',
    },
  })),
}

StyleRegistry.registerVariants('Dropzone', DropzoneStyles)
